@if (!order?.id) {
  <h1 class="border-bottom">{{ 'CREATINT_ORDER' | translate }}</h1>
}
@if (order?.id) {
  <h1 class="border-bottom">{{ 'EDITING_LOOCKING_ORDER' | translate }}</h1>
}
